<!-- Global Help Search -->
@if (allowGlobalHelpSearch) {
  <div class="cw-help-search-container cw-flex-row">
    <form class="cw-global-search-form cw-global-search-arrow">
      <input
        class="cw-global-search-input cw-color-white"
        type="text"
        placeholder="{{ 'GENERAL.SEARCH' | translate }}"
        name="searchInput"
        autocomplete="nope"
        [(ngModel)]="searchInput"
        (keyup.enter)="startSearch()"
        (keyup.shift.enter)="startSearch()" />
    </form>
    <div
      class="cw-global-search-icon"
      [ngClass]="searchInProgress ? 'icon-spinner icon-spin' : 'icon-search'"
    (click)="startSearch()"></div>
  </div>
}
